<template>
    <div class="subcontract_box animate__animated animate__fadeIn">
        <div class="subcontract">
            <div class="search_box">
                <div class="text">参建单位</div>
                <div class="search_btn" @click="fnOpenEditSubcontract('add')"><span>新增分包单位</span></div>
                <div class="search_btn upload" @click="fnUploadSubcontractGzzj"><span>同步贵州住建平台</span></div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">参建单位类型</div>
                    <div class="title_item">参建单位统一社会信用代码</div>
                    <div class="title_item">参建单位名称</div>
                    <!-- <div class="title_item">营业地址</div> -->
                    <!-- <div class="title_item">注册资本</div> -->
                    <!-- <div class="title_item">注册日期</div> -->
                    <!-- <div class="title_item">办公电话</div> -->
                    <div class="title_item">企业负责人姓名</div>
                    <div class="title_item">企业负责人联系电话</div>
                    <div class="title_item">企业负责人身份证号码</div>
                    <!-- <div class="title_item">合同图片</div> -->
                    <div class="title_item">同步时间</div>
                    <!-- <div class="title_item">操作</div> -->
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="subcontractList">
                            <div class="box_line" v-for="(item, index) in subcontractList" :key="index">
                                <div class="list_item">{{ inviteList[item.inviteType] }}</div>
                                <div class="list_item">{{ item.corpCode }}</div>
                                <div class="list_item">{{ item.corpName }}</div>
                                <!-- 			<div class="list_item">{{ item.regAddress }}</div>
								<div class="list_item">{{ item.regCapital }}</div>
								<div class="list_item">{{ item.regDate }}</div>
								<div class="list_item">{{ item.officePhone }}</div> -->
                                <div class="list_item">{{ item.pmName }}</div>
                                <div class="list_item">{{ item.pmPhone }}</div>
                                <div class="list_item">{{ item.pmIDCardNumber }}</div>
                                <!-- 				<div class="list_item">
                                    <img :src="item.images"/>
                                </div> -->
                                <div class="list_item">{{ item.upload_at ?  item.upload_at : '未同步' }}</div>
                                <!-- 		<div class="list_item">
									<div>
										<button class="item_btn blue" @click="fnOpenEditSubcontract(item)"><span>详情</span></button>
									</div>
								</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 添加分包单位弹窗 -->
            <div class="dialog_subcontract" v-if="subcontractWindow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="subcontractTitle"
                    center :visible.sync="subcontractWindow">
                    <div class="subcontract_list">
                        <div class="subcontract_item">
                            <!-- <div class="reason_body" v-if="detailId>0" style="color: #FF0000; padding-left: 20px;">提示：如需修改，请联系本平台管理员！</div> -->
                            <div class="reason_body">
                                <div class="body_item">参建单位类型</div>
                                <div class="body_item">
                                    <el-select v-model="form.inviteType" :disabled="detailId>0"
                                        :popper-append-to-body="false" filterable placeholder="请选择参建单位类型">
                                        <el-option v-for="(item, index) in inviteList" :key="index" :label="item"
                                            :value="index"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">参建单位统一社会代码</div>
                                <div class="body_item"><input type="text" class="input_box" :disabled="detailId>0"
                                        v-model="form.corpCode" placeholder="请输入9位或18位统一社会信用代码" /></div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">参建单位名称</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" :disabled="detailId>0" v-model="form.corpName"
                                        placeholder="请输入参建单位名称" />
                                </div>
                            </div>
                            <!-- <div class="reason_body">
                                <div class="body_item">注册地址</div>
                                <div class="body_item"><input type="text" class="input_box" :disabled="detailId>0" v-model="form.regAddress" placeholder="请输入注册地址" /></div>
                            </div> -->
                            <div class="reason_body">
                                <div class="body_item">公司注册所在地</div>
                                <div class="body_item"><input type="text" class="input_box" :disabled="detailId>0" v-model="form.regAreaCode" placeholder="请输入公司注册所在地区县级代码" /></div><a href="https://xingzhengquhua.bmcx.com/" target="_blank" style="color: #FF0000">代码查询</a>
                            </div>
<!--                            <div class="reason_body">
                                <div class="body_item">营业地址</div>
                                <div class="body_item"><input type="text" class="input_box" :disabled="detailId>0" v-model="form.contactAddress" placeholder="请输入营业地址" /></div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">注册资本</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" :disabled="detailId>0" v-model="form.regCapital" placeholder="请输入注册资本" />
                                </div>万元
                            </div>
                            <div class="reason_body">
                                <div class="body_item">实收资本</div>
                                <div class="body_item"><input type="text" class="input_box" :disabled="detailId>0" v-model="form.factRegCapital" placeholder="请输入实收资本" /></div>万元
                            </div> -->
                            <div class="reason_body">
                                <div class="body_item">注册日期</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" :disabled="detailId>0"
                                        v-model="form.regDate" type="date" placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>
                            <!--                           <div class="reason_body">
                                <div class="body_item">办公电话</div>
                                <div class="body_item">
                                    <span><input type="text" class="input_box" :disabled="detailId>0" v-model="form.officePhone" placeholder="请输入办公电话" /></span>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">进场时间</div>
                                <div class="body_item"><el-date-picker value-format="yyyy-MM-dd" :disabled="detailId>0" v-model="form.entryTime" type="date" placeholder="选择日期"></el-date-picker></div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">退场时间</div>
                                <div class="body_item"><el-date-picker value-format="yyyy-MM-dd" :disabled="detailId>0" v-model="form.exitTime" type="date" placeholder="选择日期"></el-date-picker></div>
                            </div> -->
                            <div class="reason_body">
                                <div class="body_item">项目经理证件号码</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" :disabled="detailId>0"
                                        v-model="form.pmIDCardNumber" placeholder="请输入项目经理证件号码" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">项目经理名称</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" :disabled="detailId>0" v-model="form.pmName"
                                        placeholder="请输入项目经理名称" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">项目经理电话</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" :disabled="detailId>0" v-model="form.pmPhone"
                                        placeholder="请输入项目经理电话" />
                                </div>
                            </div>
                            <!--                  <div class="reason_body">
                                <div class="body_item">合同图片</div>
                                <div class="body_item">
                                    <span v-if="detailId>0" @click="fnOpen(form.images)"><img :src="form.images"/></span>
                                    <el-upload class="avatar-uploader" v-else action="" list-type="picture-card" :before-upload="res=>{beforeCardPicUpload(res);}" :show-file-list="false">
                                    	<img v-if="form.images" :src="form.images" class="avatar" />
                                    	<i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="subcontractWindow = false"><span>取消</span></div>
                            <div class="search-btn" v-if="detailId==''" @click="fnAddSubcontract"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!-- 上传失败信息弹窗-->
            <div class="dialog_perError" v-if="showErrorInfo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false"
                    title="分包单位上传失败" :visible.sync="showErrorInfo" center>
                    <div class="cont_list">
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item,index) in errorInfoList" :key="index">
                                        <div class="list_item">{{ item.msg }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import {
        Loading
    } from 'element-ui';
    import {
        fnUpload
    } from '@/utils/upload';
    import * as imageConversion from 'image-conversion';
    export default {
        data() {
            return {
                showErrorInfo: false, //上传错误弹窗
                errorInfoList: [], // 错误列表
                subcontractTitle: '新增分包单位', // 弹窗名称
                detailId: '',
                form: {
                    inviteType: '', // 参建单位类型
                    corpCode: '', // 参见单位统一社会信用代码
                    corpName: '', // 参建单位名称
                    // regAddress: '', // 注册地址
                    regAreaCode: '', // 公司注册地所在地,区县级代码
                    // contactAddress: '', // 营业地址
                    // regCapital: '', // 注册资本(万元)
                    // factRegCapital: '', // 实收资本(万元)
                    regDate: '', // 注册日期
                    // officePhone: '', // 办公电话
                    // entryTime: '', // 进场时间
                    // exitTime: '', // 退场时间
                    pmIDCardNumber: '', // 项目经理证件号码
                    pmName: '', // 项目经理名称
                    pmPhone: '', // 项目经理电话
                    // images: '', // 合同图片
                },
                subcontractWindow: false, // 添加、编辑分包单位弹窗
                subcontractList: [], // 分包单位列表
                personnelList: [], // 项目下人员列表
                inviteList: { // 参建单位类型 公司字典表
                    '001': '专业分包',
                    '002': '设备分包',
                    '003': '材料分包',
                    '004': '后勤服务',
                    '005': '特殊设备',
                    '006': '劳务分包',
                    '007': '监理',
                    '008': '建设单位',
                    '009': '总承包单位',
                    '010': '勘察',
                    '011': '设计单位',
                    '012': '其它',
                    // '01': '建设方单位',
                    // '02': '总承包单位',
                    // '03': '专业分包单位',
                    // '04': '劳务分包单位',
                    // '05': '监理单位',
                    // '06': '勘察单位',
                },
            };
        },
        created() {
            this.fnInit();
        },
        methods: {
            // 初始化
            fnInit() {
                this.fnGetSubcontract({
                    region: 'gzzj'
                });
            },
            // 上传贵州住建
            fnUploadSubcontractGzzj() {
                fnRequestPlatform({
                        url: '/Gzzj/ProjectSubContractor',
                        method: 'GET'
                    },
                    res => {
                        this.fnGetSubcontract({
                            region: 'gzzj'
                        });
                        if (res.code === 1) {
                            this.$message.success(res.data);
                            return;
                        }
                        if (typeof(res.data) !== 'string') {
                            this.errorInfoList = res.data;
                            this.showErrorInfo = true;
                        } else {
                            this.$message.error(res.data);
                        }
                    }
                );
            },

            // 打开新增分包单位弹窗
            fnOpenEditSubcontract(item) {
                if (item != "add") {
                    this.subcontractTitle = '查看分包单位详情';
                    this.detailId = item.id;
                    this.form.inviteType = item.inviteType;
                    this.form.corpCode = item.corpCode;
                    this.form.corpName = item.corpName;
                    // this.form.regAddress = item.regAddress;
                    this.form.regAreaCode = item.regAreaCode;
                    // this.form.contactAddress = item.contactAddress;
                    // this.form.regCapital = item.regCapital;
                    // this.form.factRegCapital = item.factRegCapital;
                    this.form.regDate = item.regDate;
                    // this.form.officePhone = item.officePhone;
                    // this.form.entryTime = item.entryTime;
                    // this.form.exitTime = item.exitTime;
                    this.form.pmIDCardNumber = item.pmIDCardNumber;
                    this.form.pmName = item.pmName;
                    this.form.pmPhone = item.pmPhone;
                    // this.form.images = item.images;
                    this.subcontractWindow = true;
                } else {
                    this.subcontractTitle = '新增分包单位';
                    this.detailId = '';
                    this.form.inviteType = '';
                    this.form.corpCode = '';
                    this.form.corpName = '';
                    // this.form.regAddress = '';
                    this.form.regAreaCode = '';
                    // this.form.contactAddress = '';
                    // this.form.regCapital = '';
                    // this.form.factRegCapital = '';
                    this.form.regDate = '';
                    // this.form.officePhone = '';
                    // this.form.entryTime = '';
                    // this.form.exitTime = '';
                    this.form.pmIDCardNumber = '';
                    this.form.pmName = '';
                    this.form.pmPhone = '';
                    // this.form.images = '';
                    this.subcontractWindow = true;
                }
            },
            // 图片另外链接打开
            fnOpen(url) {
                window.open(url)
            },
            // 获取所有分包单位
            fnGetSubcontract(_obj, _cb) {
                request({
                        url: 'project/getAllRegionExtend',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        _cb && _cb(res);
                        console.log(res);
                        this.subcontractList = res.data;
                        if (this.subcontractList.length == 0) {
                            this.$message.warning('暂无数据');
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 添加分包单位
            fnAddSubcontract() {
                for (let key in this.form) {
                    if (!this.form[key]) {
                        return this.$message.warning('参数不能为空');
                    }
                }
                if (this.form.corpCode.length != 9 && this.form.corpCode.length != 18) {
                    return this.$message.warning('请填写9位或者18位统一社会信用代码！');
                }
                let reg = /^\d{12}$/;
                if (!reg.test(this.form.regAreaCode)) {
                    return this.$message.warning('请参照‘代码查询’，填写！')
                }

                if(this.form.inviteType >= 7 &&  this.form.inviteType <= 11){
                     return this.$message.warning('参建单位类型不能选五方主体，五方主体信息只能通过同步建委获取！')
                }

                this.form.regAreaCode = this.form.regAreaCode.substring(0, 6)
                this.form.region = 'gzzj';
                request({
                        url: 'project/addAllRegionExtend',
                        method: 'POST',
                        data: this.form
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.subcontractWindow = false;
                        this.fnGetSubcontract({
                            region: 'gzzj'
                        });
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 上传身份证头像
            beforeCardPicUpload(_file, _el) {
                let _loadingInstance = Loading.service({
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.7)',
                    spinner: 'el-icon-loading',
                    text: _el == 'photo' ? '人脸验证中…' : '图片上传中'
                });
                let _that = this;
                // 把图片文件压缩到200kb
                imageConversion.compressAccurately(_file, 200).then(_res => {
                    let reader = new FileReader();
                    reader.onload = function() {
                        let _base64 = this.result;
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile(_base64);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        if (_base64.indexOf('data:image/') != -1) {
                            _base64 = _base64.split(',')[1];
                        }
                        fnUpload(formData, res => {
                            console.log(res);
                            _that.form.images = res.data.file_url;
                            _loadingInstance.close();
                        });
                    };
                    reader.readAsDataURL(_res);
                });
                return false; // 阻止组件自动上传图片
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .subcontract_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .subcontract {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        width: 1880px;
        height: 50px;
        margin-top: 24px;
        margin-left: 20px;
        text-align: center;
        font-size: 34px;

        .search_btn {
            width: 166px;
            height: 36px;
            background: url(../../../assets/img/btn_bg_mid.png) no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 40px;
            top: 35px;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center, center);

            &.upload {
                width: 180px;
                left: 210px;
            }

            span {
                margin-top: -5px;
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        height: 755px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(2) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 267px;
                    margin-right: 30px;
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 707px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1804px;
                    height: 70px;
                    margin: 7px 0 0 30px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 190px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 306px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 286px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 267px;
                        }

                        span {
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        div {
                            @include flex-box(center, center);

                            .item_btn {
                                width: 69px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                cursor: pointer;
                                @include flex-box(center, center);

                                &.blue {
                                    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                &.red {
                                    background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                span {
                                    margin-top: -2px;
                                }
                            }
                        }

                        img {
                            width: 68px;
                            height: 68px;
                        }
                    }
                }
            }
        }
    }

    .dialog_subcontract {
        >>>.el-dialog {
            width: 550px;
            height: 470px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-dialog__body {
            padding: 10px 20px;
        }

        .subcontract_list {
            width: 510px;
            height: 330px;
            position: relative;
            overflow: hidden;

            .subcontract_item {
                position: absolute;
                left: 0;
                right: -20px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }

        .reason_body {
            width: 510px;
            height: 40px;
            line-height: 40px;
            color: #4db4f4;
            margin: 0 auto;
            @include flex-box();

            .body_item {
                height: 40px;
                color: #ffffff;

                &:first-child {
                    width: 160px;
                    text-align: center;
                }

                &:nth-child(2) {
                    width: 280px;
                }

                .input_box {
                    background-color: rgba(49, 88, 128, 0.6);
                    width: 280px;
                    height: 30px;
                    line-height: 40px;
                    padding-left: 15px;
                    color: #4db4f4;
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 280px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 2px;
                    background-color: rgba(49, 88, 128, 0.6);
                }

                img {
                    width: 100px;
                    height: 100px;
                }
            }

            >>>.el-input__inner {
                background-color: rgba(49, 88, 128, 0.6);
                width: 280px;
                height: 30px;
                border-radius: 2px;
                border: none;
                color: rgba(77, 180, 244, 0.7);

                /*background: transparent;*/
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }

            >>>.el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown {
                background-color: rgba(9, 17, 32, 1);
                border: 1px solid rgba(77, 180, 244, 1);
            }

            >>>.popper__arrow {
                border-bottom-color: rgba(77, 180, 244, 1) !important;
            }

            >>>.el-select-dropdown__item {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown__item:hover {
                color: #409eff;
            }

            >>>.el-select-dropdown__item.hover {
                color: #409eff;
            }

            >>>.el-input__icon {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.avatar-uploader {
                line-height: 100px;
                margin-right: 10px;

                img {
                    width: 98px;
                    height: 98px;
                    border-radius: 2px;
                }
            }

            >>>.el-upload--picture-card {
                background-color: transparent;
            }

            >>>.el-upload {
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
        }

        .btn_line {
            @include flex-box(center, center);
        }
    }

    // 弹窗公共样式
    .dialog_perError {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 910px;
            height: 600px;
            // margin-top: 20vh!important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }
    }

    .dialog_perError {
        >>>.el-dialog {
            width: 900px;
            height: 600px;
            // margin-top: 20vh!important;
        }

        .cont_list {
            width: 840px;
            height: 425px;
            color: #FFFFFF;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 840px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 154px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 460px;
                        margin-right: 30px;
                    }
                }
            }

            .list_boxes {
                width: 780px;
                height: 377px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 780px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1D4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            color: #F56C6C;
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 780px;
                            }

                            img {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Subcontract/SubcontractGzzj/index.vue